import React, { useState } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { Text, Title, View } from '@constants/Themed';
import moment from 'moment';
import DropDownPicker from 'react-native-dropdown-picker';
import Button from '@components/UI/Button/Button';

const CustomDatePicker = ({ onSectionPress, onValueChange, range }) => {
  const [fromDay, setFromDay] = useState(1);
  const [fromMonth, setFromMonth] = useState(1);
  const [fromYear, setFromYear] = useState(moment().year());

  const [toDay, setToDay] = useState(1);
  const [toMonth, setToMonth] = useState(1);
  const [toYear, setToYear] = useState(moment().year());

  const increment = (section, type) => {
    const setter = type === 'from' ? setFromDay : setToDay;
    switch (section) {
      case 'day':
        setter(prevDay => (prevDay < 31 ? prevDay + 1 : prevDay));
        break;
      case 'month':
        setter(prevMonth => (prevMonth < 12 ? prevMonth + 1 : prevMonth));
        break;
      case 'year':
        setter(prevYear => prevYear + 1);
        break;
      default:
        break;
    }
  };

  const decrement = (section, type) => {
    const setter = type === 'from' ? setFromDay : setToDay;
    switch (section) {
      case 'day':
        setter(prevDay => (prevDay > 1 ? prevDay - 1 : prevDay));
        break;
      case 'month':
        setter(prevMonth => (prevMonth > 1 ? prevMonth - 1 : prevMonth));
        break;
      case 'year':
        setter(prevYear => prevYear - 1);
        break;
      default:
        break;
    }
  };

  const renderDropdown = (section, items, setValue, value) => {
    const [open, setOpen] = useState(false);
    return (
      <View style={styles.rowContainer}>
        <DropDownPicker
          items={items}
          containerStyle={{ flex: 2 }}
          style={{ backgroundColor: '#fafafa' }}
          onChangeValue={(item) => setValue(item)}
          value={value}
          open={open}
          setOpen={setOpen}
          dropDownDirection='TOP'
          placeholder={`${section}`}
          placeholderStyle={{ color: '#808080' }}
          multiple={false}
          setValue={setValue}
        />

        <View style={styles.arrowsContainer}>
          <Pressable style={styles.arrow} onPress={() => increment(section, value.includes('from') ? 'from' : 'to')}>
            <Text>▲</Text>
          </Pressable>
          <Pressable style={styles.arrow} onPress={() => decrement(section, value.includes('from') ? 'from' : 'to')}>
            <Text>▼</Text>
          </Pressable>
        </View>
      </View>
    );
  };

  const getDaysInMonth = (year, month) => {
    return moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();
  };

  const getMonthItems = () => {
    return moment.months().map((month, index) => ({ label: month, value: `${index + 1}` }));
  };

  const getDayItems = () => {
    const daysInMonth = getDaysInMonth(fromYear, fromMonth);
    return Array.from({ length: daysInMonth }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` }));
  };

  const getYearItems = () => {
    const pastYearsCount = 20;
    const startYear = fromYear - pastYearsCount + 1;

    return Array.from({ length: pastYearsCount }, (_, i) => ({
      label: `${startYear + pastYearsCount - 1 - i}`,
      value: `${startYear + pastYearsCount - 1 - i}`,
    }));
  };

  return (
    <View style={styles.container}>
      {range ?
        <>
          <View style={styles.dateSection}>
            <Title style={{ minWidth: 100 }}>From</Title>
            {renderDropdown('Day', getDayItems(), setFromDay, fromDay)}
            {renderDropdown('Month', getMonthItems(), setFromMonth, fromMonth)}
            {renderDropdown('Year', getYearItems(), setFromYear, fromYear)}
          </View>
          <View style={styles.dateSection}>
            <Title style={{ minWidth: 100 }}>To</Title>
            {renderDropdown('Day', getDayItems(), setToDay, toDay)}
            {renderDropdown('Month', getMonthItems(), setToMonth, toMonth)}
            {renderDropdown('Year', getYearItems(), setToYear, toYear)}
          </View>
        </>
        :
        <View style={styles.dateSection}>
          {renderDropdown('Day', getDayItems(), setFromDay, fromDay)}
          {renderDropdown('Month', getMonthItems(), setFromMonth, fromMonth)}
          {renderDropdown('Year', getYearItems(), setFromYear, fromYear)}
        </View>
      }
      <Button buttonText={"Retrieve"} customStyle={styles.retrieveButton} onPress={() => onValueChange({ from: { day: fromDay, month: fromMonth, year: fromYear }, to: { day: toDay, month: toMonth, year: toYear } })} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 180,
    borderRadius: 20,
    paddingHorizontal: 10,
    alignItems: 'center',
    alignSelf: 'stretch',
    minWidth: '100%',
    zIndex: 20,
    backgroundColor: "transparent"
  },
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'transparent'
  },
  dateSection: {
    flex: 5,
    flexDirection: 'row',
    gap: 20,
    backgroundColor: 'transparent'
  },
  arrowsContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'transparent'
  },
  arrow: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  retrieveButton: {
    flex: 1,
    maxWidth: 200
  }
});

export default CustomDatePicker;
